export default __webpack_public_path__ + "static/media/baseline-signal_cellular_3_bar-24px.cbb1dc3e.svg";